var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vuw-ueditor"},[_c('vue-ueditor-wrap',{attrs:{"config":_vm.editorConfig},model:{value:(_vm.unit.content.html),callback:function ($$v) {_vm.$set(_vm.unit.content, "html", $$v)},expression:"unit.content.html"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }